import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { config } from '../env';

let reactPlugin: ReactPlugin | null = null;
let appInsights: ApplicationInsights | null = null;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
    /**
     * Initialize the Application Insights class
     * @return {void}
     */
    const initialise = (connectionString: string): void => {
        reactPlugin = new ReactPlugin();
        appInsights = new ApplicationInsights({
            config: {
                // connectionString,
                instrumentationKey: connectionString,
                disableInstrumentationKeyValidation: true,
                disablePageUnloadEvents: ['unload'],
                enableAutoRouteTracking: true,
                // disableAjaxTracking: true, // Disable automatic AJAX tracking
                // disableFetchTracking: true,
                // disableExceptionTracking: true, // Disable automatic exception tracking 
                extensions: [reactPlugin],
            },
        });
        appInsights!.loadAppInsights();
    };
    const connString = config.VITE_APPINSIGHTS_INSTRUMENTATIONKEY ?? 'dummy-key';
    initialise(connString);

    return { reactPlugin, appInsights };
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;
